<div class="bubble">
    <span class="filter-type">{{ filter.filterTypeText }}</span>
    <span class="filter-text">{{ filter.filterText }}</span>
    <button type="button" (click)="close()" class="bg-transparent border-0 p-0 d-print-none" [attr.aria-label]="'Remove ' + filter.filterText + ' filter'">
        <i class="icon icon-gard-close"></i>
    </button>
</div>
